function HappycallItem(props)
{
    const {item, register} = props;
    return (
        <>
        <div className="card card-item">
            <div className="card-body row">
                <div className="form-group">
                    <label style={{color:"black"}}>{item.QuestionText}</label>
                    <br/>
                    <br/>
                    <select name={item.ID} className="form-control" ref={register()}>
                        {Array.isArray(item.AnswerList) && item.AnswerList.map((answer,i) =>{
                            return (
                            <option key={i} value={answer.ID}> {answer.AnswerText}</option>
                            )
                        })}
                </select>
                </div>
            </div>
        </div>
        </>
    );
}
export default HappycallItem;